'use client'
import {KennisCentrumHeader, KennisCentrumToggle} from "./KennisCentumHeader";
import {KennisCentrumFilters} from "./KennisCentrumFilters";
import {ContentLijst} from "partials/support/Kenniscentrum/ContentLijst/ContentLijst";
import useKennisitems from "hooks/useKennisitems";
import {useSWRConfig} from 'swr'

export const KennisCentrum = ({searchParams, ingelogdeGebruiker}) => {
    const {kenniscentrumInitData} = useSWRConfig()
    const {cat, prod, typen, vid, taggroep, tekst, unlock, dash, inhoud, vers, kenmerk, fav} = searchParams;

    const {
        data,
        setSize,
        size,
        mutate,
        isLoading,
        isLoadingMore,
        isReachingEnd,
        total,
    } = useKennisitems(
      ingelogdeGebruiker?.id,
      cat,
      prod,
      typen,
      vid,
      taggroep,
      tekst,
      unlock,
      dash,
      inhoud,
      vers,
      kenmerk,
      fav,
      kenniscentrumInitData
    )

    return <section style={{maxWidth: '1140px'}}
                    className={`container mx-auto flex-auto justify-center content-center`}>
        <section className="grid grid-cols-1 sm:grid-cols-12 gap-5 mt-4">
                <section className={`col-span-12`}>
                    <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
                        <KennisCentrumHeader total={total} question={tekst || null}/>
                        <KennisCentrumToggle/>
                    </div>
                </section>

                <section className={`col-span-12 lg:col-span-3`}>
                    <KennisCentrumFilters/>
                </section>

                <section className={`col-span-12 lg:col-span-9`}>
                    <ContentLijst kennisItems={data} page={size} setSize={setSize} isLoadingMore={isLoadingMore}
                                  isLoading={isLoading} isReachingEnd={isReachingEnd} mutate={mutate}/>
                </section>
        </section>
    </section>
}
